import { useEffect, useRef, useState } from "react";

// Laat een getal in ~1,5 seconde naar zijn nieuwe waarde tellen in plaats van
// er hard heen te springen. Zelfde tempo als de meter, dus ze lopen samen op.
export function useCountUp(value, duration = 1400) {
  const [display, setDisplay] = useState(0);
  const shownRef = useRef(0);

  useEffect(() => {
    const from = shownRef.current;
    if (from === value) return undefined;

    const start = performance.now();
    let frame = 0;

    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3); // snel weg, zacht landen
      const next = Math.round(from + (value - from) * eased);
      shownRef.current = next;
      setDisplay(next);
      if (t < 1) frame = requestAnimationFrame(step);
    };

    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [value, duration]);

  return display;
}
